module.exports = __webpack_public_path__ + "static/pouyanic-cover-d4c0399e97681115a9c6c49823b41948.jpg";